/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Container, Content, Line, LoadingArea, ButtonArea } from './styles';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import api from 'api';
import moment from 'moment';
import logo from 'assets/logo-default.png';
import { formatCPF, formatCNPJ, formatPlate, formatPhone, formatZipCode, formatCurrency } from 'react-data-formatter';
import { formatPolicyStatus } from 'utils/policyStatus';
import { loadingColor, white, middleGraySecondary } from 'styles/colorProvider';
import { Button } from 'components';
import { MdChevronLeft } from 'react-icons/md';
import { BsPrinter } from 'react-icons/bs';
import { cpf } from 'cpf-cnpj-validator';

function PrintPolicy({ location, history }) {
  const policyId = parseInt(location.pathname.split('/detalhes-da-apolice/')[1]);

  const [policyData, setPolicyData] = useState({});
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    const policyNumber = {
      method: 'GET',
      url: `/policy/${policyId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      json: true,
    };
    setLoading(true);
    const response = await api(policyNumber);
    setPolicyData(response.data);
    setLoading(false);
  };

  useEffect(() => loadData(), []);

  const isCpf = cpf.isValid(policyData?.client?.cpf);

  return (
    <>
      {!loading && (
        <ButtonArea>
          <Button style={{ backgroundColor: middleGraySecondary, color: white }} height="30px" width="110px" onClick={() => history.push(`/detalhes-da-apolice/${policyId}`)}>
            <MdChevronLeft size="15" /> Voltar
          </Button>
          <Button style={{ backgroundColor: middleGraySecondary, color: white }} height="30px" width="130px" onClick={() => window.print()}>
            <BsPrinter size="15" style={{ marginRight: 10 }} />
            Imprimir
          </Button>
        </ButtonArea>
      )}
      {loading && (
        <LoadingArea>
          <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
        </LoadingArea>
      )}
      {!loading && (
        <Container>
          <Content>
            <Line>
              <header>
                <img src={logo} className="logo" alt="Logo" />
                <h1>Olá, {policyData?.user?.name?.split(' ')[0]}!</h1>
                <h2>Aqui estão todos os detalhes da sua apólice para que você possa imprimir.</h2>
              </header>
            </Line>

            <Line>
              <section>
                <h1>Dados da apólice</h1>

                <p>
                  <span>Proposta enviada por:</span> {policyData?.company?.social_reason} - CNPJ{' '}
                  {formatCNPJ(policyData?.company?.cnpj)}
                </p>
                <p>
                  <span>Apólice emitida por:</span> Split Risk Seguradora S.A. - CNPJ 43.505.273/0001-09
                </p>
                <p>
                  <span>Data da emissão:</span> {moment(policyData?.created_at).format('DD/MM/YYYY HH:mm')}
                </p>
                <p>
                  <span>Número da apólice:</span> {policyData?.code_ebao}
                </p>
                <p>
                  <span>Número do bilhete:</span> {policyData?.policy_number}
                </p>
                <p>
                  <span>Vigência do bilhete:</span> {moment(policyData?.expiration_date).format('DD/MM/YYYY')}
                </p>
                <p>
                  <span>Staus da apólice:</span> {policyData?.status && formatPolicyStatus(policyData?.status).label}
                </p>
              </section>

              <section>
                <h1>Dados do segurado</h1>

                <p>
                  <span>Nome do segurado:</span> {policyData?.user?.name}
                </p>
                <p>
                  <span>CPF:</span> {formatCPF(policyData?.user?.cpf)}
                </p>
                {isCpf && (
                  <>
                    <p>
                      <span>Data de nascimento:</span> {moment(policyData?.user?.birthdate).format('DD/MM/YYYY')}
                    </p>
                    <p>
                      <span>Sexo:</span> {policyData?.user?.gender === 1 ? 'Masculino' : 'Feminino'}
                    </p>
                  </>
                )}
                <p>
                  <span>E-mail:</span> {policyData?.user?.email}
                </p>
                <p>
                  <span>Telefone:</span> {formatPhone(policyData?.user?.phone)}
                </p>
              </section>
            </Line>

            <Line>
              <section>
                <h1>Endereço do segurado</h1>

                <p>
                  <span>Logradouro:</span> {policyData?.user?.address?.street}
                </p>
                <p>
                  <span>Número:</span> {policyData?.user?.address?.number}
                </p>
                <p>
                  <span>Bairro:</span> {policyData?.user?.address?.district}
                </p>
                <p>
                  <span>Cidade/UF:</span> {policyData?.user?.address?.city}/{policyData?.user?.address?.state}
                </p>
                <p>
                  <span>CEP</span> {formatZipCode(policyData?.user?.address?.zip_code)}
                </p>
              </section>

              <section className="printBrake">
                <h1>Dados do veículo</h1>

                <p>
                  <span>Placa:</span>{' '}
                  {policyData?.vehicle?.plate === null ? 'Sem placa' : formatPlate(policyData?.vehicle?.plate)}
                </p>
                <p>
                  <span>Marca e modelo:</span> {policyData?.vehicle?.brand} {policyData?.vehicle?.model?.split(' ')[0]}
                </p>
                <p>
                  <span>Ano fabricação/modelo:</span> {policyData?.vehicle?.manufacture_year}/{policyData?.vehicle?.year_model}
                </p>
                <p>
                  <span>Chassi:</span> {policyData?.vehicle?.chassi}
                </p>
                <p>
                  <span>GNV:</span> {policyData?.vehicle?.gnv ? 'Sim' : 'Não'}
                </p>
                <p>
                  <span>
                    Valor<sup>*</sup>:{' '}
                  </span>
                  {policyData?.vehicle && formatCurrency(policyData?.vehicle?.value)}
                </p>
                <small>* Valor da Tabela Fipe do veículo na data da contratação.</small>
              </section>
            </Line>

            <Line>
              <section>
                <h1>Dados da cobertura</h1>

                <table>
                  <thead>
                    <td width={200}>Cobertura</td>
                    <td>
                      LMI<sup>*</sup>
                    </td>
                  </thead>

                  <tbody>
                    {policyData?.coverages
                      ? policyData?.coverages.map((product) => (
                          <tr>
                            <td>{product?.name}</td>
                            <td>
                              {!product?.lmi && ''}
                              {product?.lmi_type === 'vehicle_value'
                                ? policyData?.vehicle?.value && formatCurrency(policyData?.vehicle?.value)
                                : product?.lmi_value && formatCurrency(product?.lmi_value)}
                            </td>
                          </tr>
                        ))
                      : policyData?.products?.map((product) => (
                          <tr>
                            <td>{product?.name}</td>
                            <td>
                              {!product?.lmi && '-'}
                              {product?.lmi === -1
                                ? policyData?.vehicle?.value && formatCurrency(policyData?.vehicle?.value)
                                : product?.lmi && formatCurrency(product?.lmi)}
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
                <small>* Limite máximo de indenização</small>
              </section>

              <section>
                <h1>Valores da apólice</h1>

                <p>
                  <span>Valor do prêmio:</span> {policyData?.value && formatCurrency(policyData?.value)}
                </p>
                <p>
                  <span>IOF:</span> {policyData?.value && formatCurrency(policyData?.value * 0.0738)}
                </p>
                <p>
                  <span>Taxa de juros:</span> 0%
                </p>
                <strong>
                  Valor total: {policyData?.value && formatCurrency(policyData?.value + policyData?.value * 0.0738)}
                </strong>
              </section>
            </Line>
            <Line>
              <section>
                <h1>Condições Gerais</h1>
                {policyData?.coverages?.findIndex((i) => i.name === 'Colisão') > -1 ? (
                  <p>
                    <span>COLISÃO:</span> Contratando a cobertura de colisão o SEGURADO terá direito a uma indenização em virtude
                    de prejuízos ocasionados ao veículo segurado provenientes de: a- Colisão ou capotagem acidentais; b- Queda
                    acidental em precipícios ou de pontes; c- Queda acidental de qualquer agente externo sobre o veículo segurado,
                    desde que tal agente não faça parte integrante do veículo e não esteja nele afixado; d- Queda, sobre o veículo
                    segurado, da carga por ele transportada, em decorrência de acidente de trânsito e não por simples freada; e-
                    Acidente durante seu transporte por meio apropriado, como, exemplificativamente, cegonha ou guincho; f- Atos
                    danosos praticados por terceiros, exceto os constantes no item “Prejuízos não indenizáveis para todas as
                    coberturas”; g- Despesas necessárias ao socorro e salvamento do veículo em consequência de um dos riscos
                    cobertos; h- Despesas referentes a danos materiais comprovadamente causados pelo Segurado e/ou por terceiros
                    na tentativa de evitar o sinistro, minorar o dano ou salvar a coisa.{' '}
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'Incêndio') > -1 ||
                policyData?.coverages?.findIndex((i) => i.name === 'Roubo') > -1 ||
                policyData?.coverages?.findIndex((i) => i.name === 'Fenômenos naturais') > -1 ? (
                  <p>
                    <span>INCÊNDIO, ROUBO, FURTO E FENÔMENOS NATURAIS:</span>Contratando a cobertura de roubo, furto e incêndio, o
                    SEGURADO terá direito a uma indenização em virtude de prejuízos ocasionados ao veículo segurado provenientes
                    de: a- Roubo ou furto total do veículo segurado; b- Danos sofridos pelo veículo segurado durante o tempo em
                    que, como consequência de roubo ou furto esteve em poder de terceiros, deduzida da indenização a franquia
                    estipulada na apólice para o veículo; c- Incêndio ou explosão acidental; d- Despesas necessárias ao socorro e
                    salvamento do veículo em consequência de um dos riscos cobertos e decorrente de intervenções não humanas; e-
                    Despesas referentes a danos materiais comprovadamente causados pelo Segurado e/ou por terceiros na tentativa
                    de evitar o sinistro, minorar o dano ou salvar a coisa; f- Roubo ou furto total exclusivo do rádio,
                    toca-fitas, toca cd’s, tacógrafo e kit gás, desde que tais itens façam parte do modelo original do veículo,
                    descontada do valor da indenização a franquia estipulada na apólice para o veículo.{' '}
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'Assistência 24 horas') > -1 ? (
                  <p>
                    <span>ASSISTÊNCIA 24 (VINTE E QUATRO) HORAS:</span> Prestação e serviço de assistência 24 horas aos SEGURADOS
                    em caráter emergencial mediante a impossibilidade de locomoção do veículo em acidentes, panes, roubos ou
                    furtos e fenômenos naturais, devendo ser solicitado através dos meios oficiais de comunicação, chat, WhatsApp
                    ou e-mail contato@splitrisk.com.br.{' '}
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'Faróis, lanternas e vidros ') > -1 ? (
                  <p>
                    <span>DANOS A VIDROS, FARÓIS E LANTERNAS:</span> Cobertura dos vidros laterais, traseiro, para-brisa, faróis,
                    lanternas e vidros dos retrovisores no valor máximo de R$ 1.500,00 (um mil e quinhentos reais) por item. A
                    franquia será de 20% (vinte por cento) do valor do item substituído, sendo no mínimo de R$ 60,00 (sessenta
                    reais), limitada a 2 (duas) indenizações no período de 12 (doze) meses, contados a partir da abertura do
                    primeiro evento.
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'APP - Morte') > -1 ? (
                  <p>
                    <span>APP (ACIDENTE PESSOAL POR PASSAGEIRO E DESPESAS MÉDICAS E HOSPITALARES):</span> APP (Acidente Pessoal
                    por Passageiro) Cobertura no valor de R$ 10.000,00 (dez mil reais) por passageiro do veículo integrante da
                    relação associativista, em caso de morte ou invalidez permanente. Em caso de invalidez parcial o pagamento
                    será proporcional respeitando tabela DPVAT ou similar. O APP é limitado ao valor de R$ 50.000,00 (cinquenta
                    mil reais) por veículo. O ressarcimento de despesas médicas/hospitalares é de até R$ 2.000,00 (dois mil reais)
                    por passageiro, limitado ao valor de R$ 10.000,00 (dez mil reais) por veículo, exceto passageiros de
                    motocicleta tendo em vista que os mesmos não fazem jus a referida cobertura. Os ressarcimentos serão avaliados
                    mediante comprovação documentada exigida pela empresa responsável pelo APP. Em caso de vistoria de carro 0
                    (zero) KM, ou seja, veículo novo, o APP somente ficará vigente após o efetivo emplacamento do veículo e envio
                    de nova vistoria, nos moldes deste regimento.{' '}
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'Danos a terceiros') > -1 ? (
                  <p>
                    <span>DANOS A TERCEIROS:</span> É limitado ao valor máximo de R$ 50.000,00 (cinquenta mil reais) por
                    acionamento para o veículo SEGURADO. Referido adicional, apenas se aplica, em caso de aprovação do sinistro,
                    que o SEGURADO tenha dado causa, não sendo aplicável, para caso de negativa de sinistro. Referidos valores,
                    dizem respeito apenas para danos materiais, não sendo possível reparação por danos morais, estéticos, médicos
                    e ou quaisquer outras finalidades, em conformidade com as condições gerais da SEGURADORA.{' '}
                  </p>
                ) : (
                  ''
                )}
                {policyData?.coverages?.findIndex((i) => i.name === 'Carro reserva 15 dias') > -1 ||
                policyData?.coverages?.findIndex((i) => i.name === 'Carro reserva 30 dias') > -1 ? (
                  <p>
                    <span>CARRO RESERVA:</span> Carro reserva só pode ser solicitado uma vez no período de 30 (trinta) dias em
                    casos de roubo, furto, colisão, incêndio ou fenômenos naturais indenizados pela SEGURADORA mediante aprovação
                    do sinistro e apresentação de boletim de ocorrência, respeitando todas as regras determinadas pelas locadoras
                    indicadas, em conformidade com as condições gerais da SEGURADORA.
                  </p>
                ) : (
                  ''
                )}
              </section>
            </Line>

            <Line>
              <section>
                <h1>Split Risk</h1>
                <p>
                  <span>Autorização: </span>A Split Risk é uma seguradora com autorização temporária, participante do Sandbox
                  Regulatório, sob o Processo Susep nº 15414.617648/2019-43.
                </p>
                <p>
                  <span>PORTARIA SUSEP Nº 7.828: </span>
                  https://www.in.gov.br/web/dou/-/portaria-susep-n-7.828-de-30-de-julho-de-2021-337522495{' '}
                </p>
              </section>
            </Line>
          </Content>
        </Container>
      )}
    </>
  );
}

export default PrintPolicy;
